import Model from '@/models/Model'

export default class HrFamilyBurden extends Model {
    resource() {
        return 'hr_family_burden'
    }
}